import achievementBg from './achievements/achievement-bg.png';

import logo from './icons-master/logo.svg';
import activerse from './icons-master/activerse_logo_horizontal.svg';
import backIcon from './icons-master/back.svg';

import eye from './icons-master/eye-solid.svg';
import eyeSlash from './icons-master/eye-slash-solid.svg';

import unauthorized from './image-placeholder.jpeg';

import favouriteFull from './dayplan-master/favourite_full.png';
import favouriteEmpty from './dayplan-master/favourite_empty.png';
import favouriteFullSmall from './cookbook-master/fav_small_on.png';
import favouriteEmptySmall from './cookbook-master/fav_small_off.png';
import favouritesIcon from './cookbook-master/favourites-icon.svg';
import searchIcon from './cookbook-master/input_icon_search.svg';
import favMealsIcon from './title-bar-master/fav-meals.svg';

import playBtn from './dayplan-master/play-button.svg';

import instacartLogo from './icons-master/instacart.svg';

import minus from './cookbook-master/minus.svg';
import minusMulti from './cookbook-master/minus_multi.svg';
import plus from './cookbook-master/plus.svg';
import plusMulti from './cookbook-master/plus_multi.svg';
import star from './cookbook-master/star.svg';

import iconChange from './cookbook-master/change.svg';
import iconChangeDone from './cookbook-master/change_active.svg';
import iconChangeActive from './cookbook-master/change_replace.svg';

import glass from './hydration/glass.svg';
import bottle from './hydration/bottle.svg';
import custom from './hydration/custom.svg';

import hydrationSuccessIcon from './hydration/hydration_goal_achieved.svg';
import hydrationSuccessIconLarge from './hydration/hydration_goal_achieved_large.svg';

import error404Img from './image-placeholder.jpeg';
import genericErrorImg from './image-placeholder.jpeg';
import networkErrorImg from './image-placeholder.jpeg';
import noAccountErrorImg from './image-placeholder.jpeg';
import envelope from './remove-account/envelope.svg';
import removeAccountSuccess from './remove-account/success.svg';
import removeAccountAlert from './remove-account/alert.svg';
import removeAccountError from './remove-account/error.svg';

import settingsIcon from './icons-master/settings.svg';

import appStore from './icons-master/app_store_badge.svg';
import googlePlay from './icons-master/google_play_badge.svg';

import imagePlaceholder from './image-placeholder.jpeg';
import thankYouPageBg from './image-placeholder.jpeg';
import thankYouPageBgMobile from './image-placeholder.jpeg';
import thankYouPageAppEn from './image-placeholder.jpeg';
import thankYouPageAppSe from './image-placeholder.jpeg';
import thankYouPageLogInEn from './image-placeholder.jpeg';
import thankYouPageLogInSe from './image-placeholder.jpeg';

import confirm from './image-placeholder.jpeg';

import infoIcon from './icons/info.svg';
import shoppingListIcon from './title-bar-master/shopping-list.svg';
import doneKcal from './dayplan-master/done-kcal.svg';

import changeButton from './dayplan-master/change_button.svg';
import eatenButton from './dayplan-master/eaten_button.svg';
import eatenButtonFull from './dayplan-master/eaten_button_full.svg';
import tomorrowAlertIcon from './dayplan-master/tomorrow_alert.svg';

import fastingStatusFasting from './if/fasting-status-fasting.svg';
import fastingStatusEating from './if/fasting-status-eating.svg';

import bulb from './dayplan-master/bulb.svg';
import iconChangeDone2 from './dayplan-master/change_active.svg';
import iconChangeActive2 from './dayplan-master/change_replace.svg';

import copyForTomorrow from './dayplan-master/meal.doneButtonIcon.svg';

import weightNeeded from './image-placeholder.jpeg';
import goalLost from './image-placeholder.jpeg';
import goalReached from './image-placeholder.jpeg';
import noDiet from './image-placeholder.jpeg';
import dietInFuture from './image-placeholder.jpeg';
import pendingPayment from './image-placeholder.jpeg';
import gearIcon from './dayplan-master/gear.svg';
import changeMealIcon from './dayplan-master/change_meal.svg';
import favIcon from './dayplan-master/fav_icon.svg';
import noSearchResultsIcon from './dayplan-master/no_search_results_icon.svg';
import addToMealplan from './dayplan-master/add_to_mealplan.svg';

import favouritesIcon2 from './dayplan-master/favourites-icon.svg';
import mealPlanPrice from './dayplan-master/diet_price.svg';

import ratingStarEmpty from './dayplan-master/info.ratingStarEmpty.svg';
import ratingStarHalf from './dayplan-master/info.ratingStarHalf.svg';
import ratingStarFull from './dayplan-master/info.ratingStarFull.svg';

import ratingStarPopupEmpty from './dayplan-master/popup.ratingStarEmpty.svg';
import ratingStarPopupFull from './dayplan-master/popup.ratingStarFull.svg';

import ratingButtonEmpty from './dayplan-master/button.ratingStar.empty.svg';
import ratingButtonFull from './dayplan-master/button.ratingStar.full.svg';

import buttonChange from './dayplan/button.change.svg';

import DownArrow from './icons-master/chevron-down.svg?react';
import LeftArrow from './icons/chevron-left.svg?react';
import RightArrow from './icons/chevron-right.svg?react';

import noDietImg from './image-placeholder.jpeg';
import handdrawnIcon from './shopping-list-master/handdrawn_icon.svg';

const images = {
  achievementBg,
  logo,
  activerse,
  backIcon,
  eye,
  eyeSlash,
  unauthorized,
  favouriteFull,
  favouriteEmpty,
  favouriteFullSmall,
  favouriteEmptySmall,
  favouritesIcon,
  searchIcon,
  favMealsIcon,
  playBtn,
  instacartLogo,
  minus,
  minusMulti,
  plus,
  plusMulti,
  star,
  iconChange,
  iconChangeDone,
  iconChangeActive,
  glass,
  bottle,
  custom,
  hydrationSuccessIcon,
  hydrationSuccessIconLarge,
  error404Img,
  genericErrorImg,
  networkErrorImg,
  noAccountErrorImg,
  envelope,
  removeAccountSuccess,
  removeAccountAlert,
  removeAccountError,
  settingsIcon,
  appStore,
  googlePlay,
  imagePlaceholder,
  thankYouPageBg,
  thankYouPageBgMobile,
  thankYouPageAppEn,
  thankYouPageAppSe,
  thankYouPageLogInEn,
  thankYouPageLogInSe,
  confirm,
  infoIcon,
  shoppingListIcon,
  doneKcal,
  fastingStatusFasting,
  fastingStatusEating,
  changeButton,
  eatenButton,
  eatenButtonFull,
  tomorrowAlertIcon,
  noDietImg,
  handdrawnIcon,
  bulb,
  iconChangeDone2,
  iconChangeActive2,
  weightNeeded,
  goalLost,
  goalReached,
  noDiet,
  dietInFuture,
  pendingPayment,
  changeMealIcon,
  favIcon,
  noSearchResultsIcon,
  addToMealplan,
  favouritesIcon2,
  mealPlanPrice,
  ratingStarEmpty,
  ratingStarHalf,
  ratingStarFull,
  ratingButtonEmpty,
  ratingButtonFull,
  ratingStarPopupEmpty,
  ratingStarPopupFull,
  buttonChange,
  copyForTomorrow,
  gearIcon,
};

export const svgInlineMaster = {
  DownArrow,
  LeftArrow,
  RightArrow,
};

export default images;
